export const BUYER_CAP_INV_COMP = [
    "Institutional",
    "Private",
    "Public",
    "User/Other"
];